export default __webpack_public_path__ + "static/media/README.e2e9737b.md";